var langselectortoggle = document.getElementById('langSelectorOpener');
var langselectortoggle1 = document.getElementById('langSelectorOpener1');
var langselectortoggle2 = document.getElementById('langSelectorOpener2');
var langselectorpanel = document.getElementById('langSelectorPanel');
var langselectorpanelbg = document.getElementById('langSelectorPanelBg');  
var langselectorclose = document.getElementById('langSelectorCloseBtn'); 

if(langselectortoggle) {
  langselectortoggle.addEventListener('click', function() { console.log('jfdgh');
    langselectorpanel.classList.add('open');
    langselectorpanelbg.classList.add('open');
    event.preventDefault();
  });  
}

if(langselectortoggle1) {
  langselectortoggle1.addEventListener('click', function() { console.log('jfdgh');
    langselectorpanel.classList.add('open');
    langselectorpanelbg.classList.add('open');
    event.preventDefault();
  });  
}

if(langselectortoggle2) {
  langselectortoggle2.addEventListener('click', function() { console.log('jfdgh');
    langselectorpanel.classList.add('open');
    langselectorpanelbg.classList.add('open');
    event.preventDefault();
  });  
}

langselectorclose.addEventListener('click', function() {
  langselectorpanel.classList.remove('open');
  langselectorpanelbg.classList.remove('open');
  event.preventDefault();
});

langselectorpanelbg.addEventListener('click', function() {
  this.classList.remove('open');
  langselectorpanel.classList.remove('open');
});